<template>
  <v-card
    class="ma-0 mt-0 pt-0"
    width="100%"
    flat
  >
    <v-form ref="form">
      <v-avatar
        v-if="avatar && (!selectedFile || selectedFile && selectedFile.length == 0)"
        color="primary"
        rounded
        height="auto"
        @click="handleFileImport"
        style="cursor: pointer;aspect-ratio: 1 / 1;min-width: 87px !important;"
      >
        <v-img
          class="mx-auto"
          width="250"
          src="@/assets/imagePlacholder.png"
        />
      </v-avatar>
      <v-btn
        v-if="multiple || (!avatar && (!selectedFile || selectedFile && selectedFile.length == 0))"
        color="primary"
        outlined
        style="width: 100%"
        height="32"
        :loading="isSelecting"
        @click="handleFileImport"
      >
        <v-icon left>
          mdi-upload
        </v-icon>
        {{ buttonText }}
      </v-btn>

      <!-- Create a File Input that will be hidden but triggered with JavaScript -->
      <input
        ref="uploader"
        class="d-none"
        type="file"
        name="iFiles[]"
        :accept="extensions"
        :multiple="(multiple ? true : false)"
        @input="onFileChanged"
      >
      <v-list
        v-if="selectedFile && !avatar"
        class="ma-0 pt-0"
      >
        <v-list-item
          v-for="(file, index) in selectedFile"
          :key="index"
          class="pa-0"
          link
        >
          <v-list-item-avatar
            rounded
            @click="open(file)"
          >
            <v-img
              v-show="imageFormat.includes(file.extension)"
              :alt="`${file.name} avatar`"
              :src="file.link"
            />
            <v-icon
              v-show="file.extension === '.pdf' || file.type === 'application/pdf'"
            >
              mdi-file-pdf-box
            </v-icon>
          </v-list-item-avatar>

          <v-list-item-content
            @click="open(file)"
          >
            <v-list-item-title v-text="(file.name ? file.name : file.title)" />
            <v-list-item-subtitle
              style="font-size: 11px"
              v-text="'file size : ' + file.size + ' bytes'"
            />
          </v-list-item-content>

          <v-list-item-icon>
            <v-icon
              v-show="!hideRemove"
              @click="remove(file, index)"
            >
              mdi-close
            </v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
      <div
        v-if="avatar && selectedFile"
        style="display: flex"
        :style="{width : ($vuetify.breakpoint.mobile ? '75px' : '100%')}"
      >
        <v-avatar
          rounded
          height="auto"
          width="100%"
          style="cursor: pointer;aspect-ratio: 1 / 1;min-width: 75px !important;"
          @click="open(selectedFile[0])"
        >
          <img
            style="aspect-ratio:1/1"
            :src="selectedFile[0].link"
            :alt="selectedFile[0].title"
          >
        </v-avatar>
        <v-btn
          color="pink"
          fab
          elevation="1"
          left
          style="top: -6px;left: 9px;min-width: 15px !important;z-index: 2;width: 20px;height: 20px"
          class="pa-0 flex-column-reverse"
          @click="remove(selectedFile[0], 0)"
        >
          <v-icon small>
            mdi-close
          </v-icon>
        </v-btn>
      </div>
    </v-form>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : 'primary')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
// import aicomplete from '../../components/general/AIcomplete/index'
import General from '../../../../../Mixins/general'
export default {
  name: 'UploadDialog',
  components: {
  },
  mixins: [General],
  props: ['typeProp', 'getItem', 'multiple', 'label', 'val', 'avatar', 'extensions', 'hideRemove'],
  data: () => ({
    options: {
      locale: 'en-US',
      prefix: '',
      suffix: ' ',
      precision: 0
    },
    iFiles: {},
    imageFormat: ['.jpg', '.png', '. jpg', '. png', '.PNG', '.JPEG', '.JPG', '. PNG', '. JPEG', '. JPG', '.bmp'],
    isSelecting: false,
    selectedFile: null,
    selectedMultipleFile: [],
    render: false,
    isLoading: false,
    alert: false,
    downloadLink: null,
    type: null,
    id: null,
    valid: null,
    items: null,
    file: null
  }),
  computed: {
    buttonText () {
      return this.selectedFile && !this.multiple ? this.selectedFile.name : this.$t(this.label)
    }
  },
  watch: {
    val (val) {
      if (val) {
        if (Array.isArray(this.val)) {
          this.selectedMultipleFile = this.val
          this.selectedFile = this.val
        } else {
          this.selectedFile = [this.val]
        }
      }
    },
    typeProp () {
      this.type = this.typeProp
    }
  },
  beforeMount () {
  },
  mounted () {
    if (this.typeProp) {
      this.type = this.typeProp
    }
    if (this.val) {
      if (Array.isArray(this.val)) {
        this.selectedMultipleFile = this.val
        this.selectedFile = this.val
      } else {
        this.selectedFile = [this.val]
      }
    }
  },
  methods: {
    remove (item, index) {
      const files = Array.from(this.selectedFile)
      const Multifiles = Array.from(this.selectedMultipleFile)
      this.$refs.uploader.value = null
      files.splice(index, 1)
      Multifiles.splice(index, 1)
      this.selectedFile = files
      this.selectedMultipleFile = Multifiles
      if (this.selectedFile.length > 0) {
        this.$emit('input', this.selectedFile)
      } else {
        this.selectedFile = null
        this.$emit('input', null)
      }
    },
    open (file) {
      if (!file) return

      const url = file.url || file.link

      if (!url) {
        console.warn('No url or link found for file:', file)
        return
      }

      window.open(
        url,
        '_blank',
        'toolbar=yes,scrollbars=yes,resizable=yes,width=600,height=500'
      )
    },
    create (id) {
      var app = this
      app.isLoading = true
      var formData = new FormData()
      if (this.selectedFile) {
        for (var i = 0; i < this.selectedFile.length; i++) {
          const file = this.selectedFile[i]
          formData.append('files[' + i + ']', file)
          formData.append('selectedFile[' + i + ']', JSON.stringify(file))
        }
      }
      formData.append('refId', id)
      formData.append('type', this.type)
      formData.append('select', 'fileUpload')
      app.$axios.post(this.$endpoint + 'createdetail', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(res => {
          // app.$emit('close')
        })
        .catch(err => {
          this.serverErrorHandeler(err)
        })
        .finally(() => (this.isLoading = false))
    },
    handleFileImport () {
      this.isSelecting = true

      // After obtaining the focus when closing the FilePicker, return the button state to normal
      window.addEventListener('focus', () => {
        this.isSelecting = false
      }, { once: true })

      // Trigger click on the FileInput
      this.$refs.uploader.click()
    },
    onFileChanged (e) {
      if (!this.multiple) {
        this.$emit('input', e.target.files)
      }
      if (this.multiple) {
        for (let i = 0; i < e.target.files.length; i++) {
          this.selectedMultipleFile.push(e.target.files[i])
        }
        this.selectedFile = this.selectedMultipleFile
      } else {
        this.selectedFile = e.target.files
      }
      // this.selectedFile = e.target.files
      for (let i = 0; i < this.selectedFile.length; i++) {
        if (this.selectedFile[i].size > 500000) {
          this.snakbarText = this.$t('fileShouldBeLessThan500KB')
          this.snakbarColor = 'pink'
          this.snakbar = true
          this.remove(this.selectedFile[i], i)
        } else {
          if (!this.selectedFile[i].id) {
            this.selectedFile[i].link = URL.createObjectURL(this.selectedFile[i])
            this.selectedFile[i].extension = '. ' + this.selectedFile[i].name.split('.')[1]
            this.selectedFile[i].title = this.selectedFile[i].name.split('.')[0]
            this.selectedFile[i]._id = this.selectedFile[i].size + '' + this.selectedFile[i].lastModified
            this.selectedFile[i].iconURL = ''
          }
        }
      }
      if (this.multiple) {
        this.$emit('input', this.selectedFile)
      }
    }
  }
}
</script>

<style scoped>

</style>
